/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_138_TitleInputs */

const en_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red Spider Lily`)
};

const ar_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنبق العنكبوت الأحمر`)
};

const de_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rote Spinnenlilie`)
};

const es_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lirio araña rojo`)
};

const fr_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lys Araignée Rouge`)
};

const it_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giglio Ragno Rosso`)
};

const ja_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒガンバナ`)
};

const ko_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`붉은 거미 백합`)
};

const pt_br_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lírio-aranha-vermelha`)
};

const ru_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ликорис лучистый`)
};

const th_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พลับพลึงแดง`)
};

const tr_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kırmızı Örümcek Zambağı`)
};

const zh_cn_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`石蒜`)
};

const zh_tw_tree_type_138_title = /** @type {(inputs: Tree_Type_138_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`石蒜`)
};

/**
* | output |
* | --- |
* | "Red Spider Lily" |
*
* @param {Tree_Type_138_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_138_title = /** @type {((inputs?: Tree_Type_138_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_138_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_138_title(inputs)
	if (locale === "ar") return ar_tree_type_138_title(inputs)
	if (locale === "de") return de_tree_type_138_title(inputs)
	if (locale === "es") return es_tree_type_138_title(inputs)
	if (locale === "fr") return fr_tree_type_138_title(inputs)
	if (locale === "it") return it_tree_type_138_title(inputs)
	if (locale === "ja") return ja_tree_type_138_title(inputs)
	if (locale === "ko") return ko_tree_type_138_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_138_title(inputs)
	if (locale === "ru") return ru_tree_type_138_title(inputs)
	if (locale === "th") return th_tree_type_138_title(inputs)
	if (locale === "tr") return tr_tree_type_138_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_138_title(inputs)
	return zh_tw_tree_type_138_title(inputs)
});